<template lang="pug">
  v-dialog(:value="showDialog",max-width="500px" @click="close" @click:outside="close")
      v-row.ma-0
        v-col(align="center" cols="12")
          v-card.align-center(dark color="primary" height="100%" width="100%"  )
            Info
            v-divider
            v-row(justify="center")
              v-col.py-0()
                v-btn(icon href="https://www.facebook.com/cityofrefugeucc/" target="_blank" )
                  v-icon.mdi.mdi-facebook(small)
              v-col.py-0()
                v-btn(icon href="http://www.twitter.com/cityofrefugeucc" target="_blank" )
                  v-icon.mdi.mdi-twitter(small)
              v-col.py-0()
                v-btn(icon href="https://www.youtube.com/channel/UCPd1Uyo-ATz_O07DRL8jY0g" target="_blank")
                  v-icon.mdi.mdi-youtube(small)
              v-col.py-0()
                v-btn(icon href="http://www.instagram.com/cityofrefugeucc" target="_blank")
                  v-icon.mdi.mdi-instagram(small)
              v-col.py-0()
                v-btn(icon href="mailto:info@cityofrefugeucc.org" target="_blank")
                  v-icon.mdi.mdi-email(small)
            v-divider
            v-card-actions
                v-spacer
                v-btn(text color='info' @click.stop="close") Close
</template>

<script>
// import { getSunday } from '../../plugins/getDays';
import Info from '../contact/info';
export default {
  components: {
    Info
  },
  props: {
    dialog: {
      default: false
    }
  },
  // created() {
  //   this.getSunday = getSunday();
  // },
  data() {
    return {};
  },
  computed: {
    showDialog() {
      console.log('TCL: get -> this.dialog', this.dialog);
      return this.dialog;
    }
  },
  methods: {
    close() {
      console.log('dialog', this.dialog);
      this.$emit('update:dialog', false);
    }
  }
};
</script>

<style lang="stylus" scoped></style>
